function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Radio, Alert, Table, Form, Image } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MedicalReport = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  //console.log(JSON.stringify(customer));     
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  useEffect(function () {
    form.setFieldsValue({
      conclusion: candidat.conclusion.conclusion
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        children: [/*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 4
          }), /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 2,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                padding: "14px",
                color: "#7C1F21",
                background: "#EFE1E1",
                clear: "both",
                borderRadius: "11px"
              },
              children: /*#__PURE__*/_jsxs(ARow, {
                children: [/*#__PURE__*/_jsx(ACol, {
                  span: 4,
                  children: /*#__PURE__*/_jsx(Image, {
                    src: "drawables/emgl.png",
                    preview: false,
                    width: "70px"
                  })
                }), /*#__PURE__*/_jsxs(ACol, {
                  span: 20,
                  children: [/*#__PURE__*/_jsx("h2", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "SYNTHESE MEDICALE DE LA VISITE"
                    })
                  }), /*#__PURE__*/_jsxs("span", {
                    children: ["N\xBA RP", candidat.candidate_code]
                  })]
                })]
              })
            })
          })]
        }), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs("div", {
              className: "pad cool-radius",
              children: [/*#__PURE__*/_jsxs("p", {
                style: {
                  fontSize: "16px"
                },
                children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "INFOS PATIENT"
                  }),
                  bordered: true,
                  column: 1,
                  size: "small",
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "NOM COMPLET"
                    }),
                    children: candidat.name
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "\xC2GE"
                    }),
                    children: [moment(candidat.birthdate).diff(moment(), 'years') * -1, " ans. "]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "POSTE DE TRAVAIL"
                    }),
                    children: candidat.job
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MATRICULE"
                    }),
                    children: candidat.matricule
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "LIEU DE RESIDENCE"
                    }),
                    children: candidat.address
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "ENTREPRISE"
                    }),
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsx("br", {})]
              }), /*#__PURE__*/_jsxs("p", {
                children: [/*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    style: {
                      fontWeight: "bolder"
                    },
                    children: "ETAT GENERAL"
                  })
                }), candidat.conclusion.mr_general_state]
              }), /*#__PURE__*/_jsx(Divider, {}), candidat.medecine_questions != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "CONSTANTES"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Poids"
                  }),
                  children: [candidat.medecine_questions.weight, " Kg"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Tension"
                  }),
                  children: [candidat.medecine_questions.arterial_pressure, " mmHg"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "TAILLE"
                  }),
                  children: [candidat.medecine_questions.height, " cm"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "FREQ. CARDIAQUE"
                  }),
                  children: [candidat.medecine_questions.cardiac_frequency, " pouls/min"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "FREQ. RESPIRATOIRE"
                  }),
                  children: [candidat.medecine_questions.breathe_frequency, " Cycle/min"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "TEMPERATURE"
                  }),
                  children: [candidat.medecine_questions.temperature, " \xB0C"]
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.visio_test != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "VISIO TEST"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "BINOCULAIRE (VISION DE PRES)"
                  }),
                  children: [candidat.visio_test.binocular, " "]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "BINOCULAIRE (VISION DE LOIN)"
                  }),
                  children: [candidat.visio_test.f_binocular, " "]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "DROIT (VISION DE PRES)"
                  }),
                  children: candidat.visio_test.rightsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "DROIT (VISION DE LOIN)"
                  }),
                  children: candidat.visio_test.f_rightsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "GAUCHE (VISION DE PRES)"
                  }),
                  children: candidat.visio_test.leftsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "GAUCHE (VISION DE LOIN)"
                  }),
                  children: candidat.visio_test.f_leftsight
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.audio_test != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "AUDIO TESTE"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CA GAUCHE"
                  }),
                  children: [candidat.audio_test.hcleft, " "]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CA DROIT"
                  }),
                  children: candidat.audio_test.hcright
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.spirometrie != null && /*#__PURE__*/_jsx(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "SPIROMETRIE"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ETAT"
                  }),
                  children: [candidat.spirometrie.status == 0 ? "ANORMAL" : "NORMAL", " "]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx("p", {
                  children: candidat.conclusion.mr_conclusion != null && /*#__PURE__*/_jsx(Alert, {
                    type: "info",
                    banner: true,
                    message: /*#__PURE__*/_jsx("b", {
                      children: "CONCLUSION"
                    }),
                    showIcon: false,
                    description: candidat.conclusion.mr_conclusion
                  })
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
                type: "info",
                banner: true,
                message: /*#__PURE__*/_jsx("b", {
                  children: "RECOMMANDATION"
                }),
                showIcon: false,
                description: candidat.conclusion.mr_recommandation != null && candidat.conclusion.mr_recommandation != "undefined" && candidat.conclusion.mr_recommandation != "null" && /*#__PURE__*/_jsx("b", {
                  children: candidat.conclusion.mr_recommandation
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Conakry, le "
                }), /*#__PURE__*/_jsx(Moment, {
                  date: candidat.conclusion.created_at,
                  format: "DD/MM/YYYY"
                })]
              }), /*#__PURE__*/_jsx("br", {})]
            })
          })
        }), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Le M\xE9decin"
                })
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
          type: "info",
          message: /*#__PURE__*/_jsx("b", {}),
          description: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
              children: ["Adresse: Coleyah, Commune de Matam, Conakry, R\xE9p. de Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                children: "Tel: +224 620 00 00 00 - E-mail: info@emg-acid.com"
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default MedicalReport;